/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

export default styled.div`
  display: flex;
  margin-top: ${scale.major(2)}px;
  > button:nth-child(2) {
    margin-left: auto;
  }
`;
